<template>
    <section class="intake-section">
        <h3 v-if="title" class="intake-section__title">{{ title }}</h3>
        <div class="intake-section__body">
            <slot></slot>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            title: { type: String, default: '' },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_functions.scss';
    @import 'styles/setup/_mixins.scss';

    .intake-section {
        margin: 0 0 rem(24px);
        padding: rem(16px);
        border: rem(1px) solid $color--border-base;
        border-radius: rem($border-radius--base);
        background: #fff;

        @include breakpoint(tablet) {
            padding: rem(14px);
        }
    }

    .intake-section__title {
        margin: 0 0 rem(16px);
        font-size: rem($font-size--form);
        font-weight: 700;
        line-height: 1.3;
        color: $color--txt-header;
        text-align: left;
    }

    .intake-section__body {
        min-width: 0;
    }
</style>
